<template>
    <div
        class="w-full md:w-11/12 mx-auto bg-theme-canvas border border-theme-border rounded-lg shadow-lg p-4"
    >
        <div class="grid grid-cols-7 gap-2 mb-4">
            <div
                v-for="weekday in weekdays"
                :key="weekday"
                class="text-center font-semibold text-theme-muted py-2"
            >
                {{ weekday }}
            </div>
        </div>
        <div class="grid grid-cols-7 gap-2">
            <button
                v-for="day in days"
                :key="day.date"
                class="w-12 h-12 flex items-center justify-center rounded-full text-sm font-medium transition-colors relative hover:bg-theme-hover"
                :class="{
                    'bg-theme-success text-white': day.isToday,
                    'text-theme-muted': day.isOtherMonth,
                    'text-theme-disabled cursor-not-allowed opacity-50':
                        day.isDisabled,
                    'ring-2 ring-theme-primary': day.itemsNumber
                }"
                :disabled="day.isDisabled"
                @click="selectDay(day.date)"
            >
                <span
                    v-if="day.itemsNumber"
                    class="absolute -top-1 -right-1 bg-theme-danger text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold"
                >
                    {{ day.itemsNumber }}
                </span>
                {{ day.day }}
            </button>
        </div>
    </div>
</template>

<script>
import { DateTime } from "luxon";

import { TIMEZONE } from "@/common/constants";

export default {
    components: {},
    props: {
        startDate: {
            type: String,
            required: true
        },
        endDate: {
            type: String,
            required: true
        },
        itemsByDate: {
            type: Object,
            default: () => ({}),
            required: true
        }
    },
    data() {
        return {
            weekdays: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
            days: []
        };
    },
    computed: {},
    watch: {
        itemsByDate() {
            this.generateCalendar();
        },
        startDate() {
            this.generateCalendar();
        }
    },
    mounted() {
        this.generateCalendar();
    },
    methods: {
        buildItemsNumber(date) {
            if (date in this.itemsByDate) {
                return this.itemsByDate[date].length;
            }
            return 0;
        },
        generateCalendar() {
            this.days = [];
            const startDateIso = DateTime.fromISO(this.startDate).setZone(
                TIMEZONE
            );
            const endDateIso = DateTime.fromISO(this.endDate).setZone(TIMEZONE);
            const startOfMonth = startDateIso.startOf("month");
            const endOfMonth = startDateIso.endOf("month");

            const lastDay = endOfMonth.setZone(TIMEZONE).endOf("week");
            const now = DateTime.now();
            let currentDay = startOfMonth.setZone(TIMEZONE).startOf("week");
            while (currentDay <= lastDay) {
                const isDisabled =
                    currentDay < startDateIso || currentDay > endDateIso;
                const date = currentDay.toISODate();
                const itemsNumber = this.buildItemsNumber(date);
                this.days.push({
                    date,
                    day: currentDay.day,
                    isToday: currentDay.hasSame(now, "day"),
                    isOtherMonth: !currentDay.hasSame(startDateIso, "month"),
                    isDisabled: isDisabled,
                    itemsNumber
                });
                currentDay = currentDay.plus({ days: 1 });
            }
        },
        selectDay(date) {
            if (!this.days.find((day) => day.date === date).isDisabled) {
                this.$emit("day-click", date);
            }
        }
    }
};
</script>
